/* eslint-disable import/no-cycle */
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  CityProps,
  CountryProps,
  StateProps,
} from "../../../../../domain/models/address.model";
import { CNAESModel } from "../../../../../domain/models/cnae";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { FilterModel } from "../../../../../domain/models/enum";
import { Currencyprops } from "../../../../../domain/models/invoice";
import { TakerModel } from "../../../../../domain/models/taker";
import { ViaCepResponse } from "../../../../../domain/models/via-cep";
import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";
import { makeRemoteInvoice } from "../../../../../main/factories/usecases/invoice/remote-invoice-factory";
import ButtonComponent from "../../../../components/button";
import ButtonRound from "../../../../components/button-action";
import { ItemField } from "../../../../components/datagrid";
import { GroupProp } from "../../../../components/form-factory/utils/util";
import Icons from "../../../../components/icons-helper";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "./styles";

export const FilterFields = (setParams: any): GroupProp[] => {
  const [values, setValues] = useState<string>("");
  return [
    {
      groupName: "FILTER",
      items: [
        {
          name: "socialReason",
          type: "text",
          label: "Nome:",
          onChange: (e) => {
            setValues(e);
          },
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorSearch",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Pesquisar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({
                    ...prev,
                    filters: `socialReason~${values}`,
                  }))
                }
              />
            </div>
          ),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorClear",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Limpar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({ ...prev, filters: null }))
                }
              />
            </div>
          ),
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};
export const Fields = (
  cnaesList: CNAESModel[],
  developerCompaniesList: DeveloperCompanyModel[],
): GroupProp[] => {
  const [countries, setCountries] = useState<CountryProps[]>([]);

  const [currenciesList, setCurrenciesList] = useState<Currencyprops[]>([]);

  const [selectedCountry, setSelectedCountry] = useState<any>("Brasil");

  const [addressByCep, setAddressByCep] = useState<ViaCepResponse | null>(null);

  useEffect(() => {
    (async () => {
      const listCurrencies = await makeRemoteInvoice().currency();
      setCurrenciesList(listCurrencies);
      const countriesData = await makeRemoteAddresss().loadCountries();
      setCountries(countriesData);
    })();
  }, []);
  return [
    {
      groupName: "TOMADOR",
      groupLabel: "Selecione sua empresa:",
      items: [
        {
          name: "company",
          type: "select",
          label: "Selecione a empresa que prestou o serviço*:",
          validations: "inputRequired",
          options: developerCompaniesList?.map((el) => ({
            value: el.company?.id,
            label: el.company?.socialReason,
            subscriptionNumber: el.company?.subscriptionNumber,
          })),
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    {
      groupName: "Company",
      groupLabel: "Dados do Tomador:",
      items: [
        {
          name: "companyName",
          type: "text",
          label: "Nome da Empresa*:",
          placeholder: "Digite Aqui",
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "postalCode",
          type: "text",
          label: "Código Postal:",
          placeholder: "Digite Aqui",
          mask: "00000-000",
          validations: selectedCountry === "Brasil" ? "inputRequired" : "",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
          onChange: async (val: string) => {
            if (selectedCountry === "Brasil") {
              const parseCep = val.replace("-", "");
              if (parseCep.length === 8) {
                const res: { data: ViaCepResponse } = await axios.get(
                  `https://viacep.com.br/ws/${parseCep}/json/`,
                );

                setTimeout(() => {
                  setAddressByCep(res.data);
                }, 500);
              }
            } else {
              setAddressByCep(null);
            }
          },
        },
        {
          name: "address",
          type: "text",
          label: "Endereço:",
          placeholder: "Digite Aqui",
          validations: "inputRequired",
          defaultValue: addressByCep?.logradouro,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "country",
          type: "select",
          label: "País*:",
          placeholder: "Selecione Aqui",
          value: 1,
          onChange: (e: any) => {
            const selected = countries.find((el) => el.id === e.target.value);
            setSelectedCountry(selected?.name);
          },
          options: countries.map((el) => ({ value: el.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "state",
          type: "text",
          label: "Estado:",
          defaultValue: addressByCep?.uf,
          placeholder: "Digite Aqui",
          validations: selectedCountry === "Brasil" ? "inputRequired" : "",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "text",
          label: "Cidade:",
          defaultValue: addressByCep?.localidade,
          /* defaultValue: addressByCep
            ? citiesList?.find(
                (el: CityProps) =>
                  el?.name?.toLowerCase() ===
                  addressByCep?.localidade?.toLowerCase()
              )?.id
            : null, */
          placeholder: "Digite Aqui",
          validations: selectedCountry === "Brasil" ? "inputRequired" : "",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "SERVICE",
      groupLabel: "Descrição e Valores:",
      items: [
        {
          name: "description",
          type: "textarea",
          label: "Discriminação do(s) serviço(s) prestado(s)*:",
          options: [
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "none", label: "Não Existe" },
          ],
          validations: "inputRequired",
          rows: 6,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "date",
          type: "date",
          label: "Data*:",
          placeholder: "0,00",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "currency",
          type: "select",
          label: "Moeda*:",
          placeholder: "Selecione Aqui",
          validations: "inputRequired",
          options: currenciesList?.map((el) => ({
            value: `${el.name} - (${el.code}) - ${el.symbol} - ${el.id}`,
            label: `${el.name} - (${el.code})`,
            currency: el,
          })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "serviceValue",
          type: "currency",
          label: "Valor do(s) serviço(s)*:",
          placeholder: "0,00",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "Bank",
      groupLabel: "Dados Bancários:",
      items: [
        {
          name: "bankName",
          type: "text",
          label: "Banco*:",
          validations: "inputRequired",
          rows: 6,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "bankAgency",
          type: "text",
          label: "Agência*:",
          placeholder: "00000",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "bankAccount",
          type: "text",
          label: "Conta*:",
          placeholder: "000000",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "bankDigit",
          type: "text",
          label: "Dígito*:",
          placeholder: "00",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
  ];
};

export const FieldsTomador = (
  data: TakerModel | null | undefined,
): GroupProp[] => {
  const [addressByCep, setAddressByCep] = useState<ViaCepResponse | null>(null);
  const [docType, setDocType] = useState<"CNPJ" | "CPF">("CPF");

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador:",
      items: [
        {
          name: "documentTypeEnum",
          type: "radio",
          defaultValue: data?.documentTypeEnum || "CPF",
          label: "Documento*",
          onChange: (e) => {
            setDocType(e);
          },
          options: [
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "NONE", label: "Não Existe" },
          ],
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "documentNumber",
          type: "text",
          label: "CPF/CNPJ:",
          defaultValue: data?.documentNumber,
          placeholder:
            docType === "CPF" ? "000.000.000-00" : "00.000.000/0000-00",
          mask: docType === "CPF" ? "000.000.000-00" : "00.000.000/0000-00",
          validations: docType === "CPF" ? "cpfValidation" : "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "municipalRegistration",
          type: "text",
          label: "Inscrição Municipal:",
          defaultValue: data?.municipalRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "stateRegistration",
          type: "text",
          label: "Inscrição Estadual:",
          defaultValue: data?.stateRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "socialReason",
          type: "text",
          label: "Razão Social/Nome*:",
          defaultValue: data?.socialReason,
          placeholder: "",
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "zipCode",
          type: "text",
          label: "CEP:",
          mask: "00000-000",
          // validations: 'inputRequired',
          defaultValue: data?.address?.zipCode,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
          onChange: async (val: string) => {
            const parseCep = val.replace("-", "");
            if (parseCep.length === 8) {
              const res: { data: ViaCepResponse } = await axios.get(
                `https://viacep.com.br/ws/${parseCep}/json/`,
              );

              setTimeout(() => {
                setAddressByCep(res.data);
              }, 500);
            }
          },
        },
        {
          name: "address",
          type: "text",
          label: "Endereço",
          validations: "inputRequired",
          defaultValue: addressByCep?.logradouro || data?.address?.place,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "number",
          type: "text",
          label: "Número:",
          validations: "inputRequired",
          defaultValue: data?.address?.number,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "district",
          type: "text",
          label: "Bairro:",
          validations: "inputRequired",
          defaultValue: addressByCep?.bairro || data?.address?.district,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complement",
          type: "text",
          label: "Complemento:",
          defaultValue: data?.address?.complement,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "state",
          type: "text",
          label: "Estado:",
          defaultValue: data?.address?.state || addressByCep?.uf,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "text",
          label: "Cidade:",
          defaultValue: data?.address?.city || addressByCep?.localidade,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "email",
          type: "text",
          label: "E-mail:",
          // validations: 'emailRequired',
          defaultValue: data?.email,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "taxSubstitute",
          type: "radio",
          defaultValue: `${data?.taxSubstitute}`,
          label: "Substituto Tributária*",
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
      ],
    },
  ];
};
export const FieldsCNAES = (): GroupProp[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);

  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  useEffect(() => {
    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, []);

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "CNAE:",
      items: [
        {
          name: "code",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "description",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },

        {
          name: "state",
          type: "select",
          label: "Estado:",
          validations: "inputRequired",
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          validations: "inputRequired",
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "Activity",
      groupLabel: "Atividade Econômica:",
      items: [
        {
          name: "codeActivity",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "descriptionActivity",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "aliquot",
          type: "number",
          label: "Aliquota:",
          validations: "inputRequired",
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};

export const fieldsGrid = (
  setShow: any,
  setShowGrid: any,
  setSelected: any,
): ItemField[] => [
  {
    title: "Documento",
    key: "id",
    renderItem: (data: TakerModel) => data.documentNumber,
  },
  {
    title: "Nome",
    key: "createdAt",
    renderItem: (data: TakerModel) => data.socialReason,
  },
  {
    title: "",
    key: "actions",
    renderItem: (data) => (
      <ContainerButtonActions>
        <ButtonRound
          backgroundColor={theme.colors.white}
          onClick={() => {
            setSelected(data);
            setShowGrid(false);
            setShow(true);
          }}
          title="Editar"
          color={theme.colors.lightBlue}
        >
          <Icons
            height={25}
            width={25}
            name="edit"
            color={theme.colors.primary}
          />
        </ButtonRound>
      </ContainerButtonActions>
    ),
  },
];
